module.exports = __webpack_public_path__ + "assets/img/u1331.b93afc1d.png";